import { useCallback, useState } from 'react';

import { defaultProps, initialState } from './constants';

/**
 * React Hook for anchor params used in Material Modal-like components
 * @param {object} [anchorPositionOffset] - offset coordinates for modal (if position will be applied via coordinates).
 * @returns {object} Returns params for modal.
 */

const usePopover = withoutStopPropagation => {
  const { anchorPositionOffset } = defaultProps;
  const [params, setParams] = useState(initialState);

  const onSetAnchorPosition = useCallback(
    e => {
      e?.stopPropagation?.();

      const anchorPosition = {
        top: e.clientY + anchorPositionOffset.y,
        left: e.clientX + anchorPositionOffset.x,
      };

      setParams(prevState => ({ ...prevState, anchorPosition }));
    },
    [anchorPositionOffset.y, anchorPositionOffset.x],
  );

  const onClearAnchorPosition = useCallback(() => {
    setParams(prevState => ({ ...prevState, anchorPosition: null }));
  }, []);

  const onSetAnchorElement = useCallback(
    (e, ref) => {
      if (!withoutStopPropagation) {
        e?.stopPropagation?.();
      }

      const { currentTarget } = e ?? {};
      const currentRef = ref?.current;

      setParams(prevState => ({ ...prevState, anchorEl: currentTarget || currentRef }));
    },
    [withoutStopPropagation],
  );

  const onClearAnchorElement = useCallback(e => {
    e?.stopPropagation?.();

    setParams(prevState => ({ ...prevState, anchorEl: null }));
  }, []);

  return {
    ...params,
    onSetAnchorElement,
    onClearAnchorElement,
    onSetAnchorPosition,
    onClearAnchorPosition,
  };
};

export default usePopover;
